var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M766.16,198.04l-132.25,42.55-18.41-58.64,311.66-100.05-103.5,309.34-58.66-19.55,42.55-128.8-226.55,227.69c42.94,55.22,62.3,117.12,58.08,185.73-4.22,68.62-30.48,127.08-78.78,175.38-52.91,52.89-116.92,79.34-192.05,79.34s-139.16-26.45-192.06-79.34c-52.91-52.91-79.34-116.92-79.34-192.05s26.45-139.16,79.36-192.06c48.3-48.28,106.75-74.55,175.38-78.77,68.61-4.22,130.52,15.14,185.72,58.08l228.86-228.86ZM219.32,491.87c-41.02,41.03-61.52,90.48-61.52,148.36s20.5,107.14,61.52,147.77c41.02,40.64,90.47,60.95,148.36,60.95s107.33-20.31,148.34-60.95c41.02-40.62,61.53-89.89,61.53-147.77s-20.52-107.33-61.53-148.36c-41.02-41.02-90.47-61.53-148.34-61.53s-107.34,20.52-148.36,61.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarte);
export default __webpack_public_path__ + "static/media/Marte.af534bab0911b16af4509493b2b33d8e.svg";
export { ForwardRef as ReactComponent };